<nz-tag *ngFor="let tag of value; let i = index" [nzMode]="'closeable'" (nzOnClose)="handleClose(tag)">
  {{ sliceTagName(tag) }}
</nz-tag>
<nz-tag *ngIf="!inputVisible" class="editable-tag" nzNoAnimation (click)="showInput()">
  <i nz-icon nzType="plus"></i>
  {{ 'NewTag' }}
</nz-tag>

<!-- String -->
<input
  [name]="name + '_add'"
  #inputElement
  nz-input
  nzSize="small"
  *ngIf="inputVisible && dataType === type.String"
  type="text"
  [(ngModel)]="inputValue"
  style="width: 78px"
  (blur)="handleInputConfirm()"
  (keydown.enter)="handleInputConfirm()"
/>
<!-- Float & auto-focus -->
<nz-input-number
  [name]="name + '_add'"
  #inputElement
  nz-input
  nzSize="small"
  *ngIf="inputVisible && (dataType === type.Float || dataType === type.Decimal)"
  [(ngModel)]="inputValue"
  style="width: 78px"
  (blur)="handleInputConfirm()"
  (keydown.enter)="handleInputConfirm()"
></nz-input-number>

<!-- Integer -->
<nz-input-number
  [name]="name + '_add'"
  #inputElement
  nz-input
  [nzStep]="1"
  nzPrecisionMode="cut"
  [nzPrecision]="0"
  nzSize="small"
  *ngIf="inputVisible && dataType === type.Integer"
  [(ngModel)]="inputValue"
  style="width: 78px"
  (blur)="handleInputConfirm()"
  (keydown.enter)="handleInputConfirm()"
>
</nz-input-number>

<span>点击输入,回车键新增</span>
